class LoaderService {
  constructor() {
    this.listeners = [];
    this.loading = false;
  }

  subscribe(callback) {
    this.listeners.push(callback);
    callback(this.loading);
    return {
      unsubscribe: () => {
        this.listeners = this.listeners.filter(listener => listener !== callback);
      }
    };
  }

  show() {
    this.loading = true;
    this.listeners.forEach(listener => listener(true));
  }

  hide() {
    this.loading = false;
    this.listeners.forEach(listener => listener(false));
  }
}

export default new LoaderService();
